window.DocumentoAbertoController = ControllerBase.extend({
    name: "DocumentoAbertoController",

    dataBreadcrumb: new DataBreadcrumb({
        columns: [
            { title: 'CPF/CNPJ', prop: 'CpfCnpj' },
            { title: 'Nome', prop: 'Nome' }
        ],
        getData: function () {

            var cliente = this.cliente
                ? this.cliente
                : ControllerBase.instances['CadastroClienteController'].model;

            return this.toJS(cliente);
        },
    }),

    ajax: function() {

        return {
            url: "/Cliente/_DocumentoAberto",
            type: "post",
            cache: false,
            contentType: "application/json",
            data: JSON.stringify({
                pesquisa: this.pesquisa
            })
        };
    },

    renderizado: function() {

        $("#documento-aberto-container").removeClass("none").addClass("separador");

        this.DocumentoAbertoView = this.showView({
            region: {
                name: "documentoAbertoViewRegion",
                selector: "#documento-aberto-view-region"
            },
            view: {
                type: DocumentoAbertoView,
                args: {
                    model: new PesquisarDocumentosAberto(this.model),
                    collection: new Documentos(this.model.Documentos)
                }
            }
        });
    }
});